import React from 'react';

/**
 * A banner that appears at the top of every page to indicate we're in a test/development environment.
 * This component is automatically excluded from production builds using Vite's tree-shaking
 * when import.meta.env.PROD is true.
 */
const DevelopmentBanner: React.FC = () => {
  // Only render in non-production environments
  if (import.meta.env.PROD) {
    return null;
  }

  // Determine environment type for display
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
  const isLocal = supabaseUrl.includes('localhost') || supabaseUrl.includes('127.0.0.1');

  let environmentLabel = 'Development';
  let bgColor = 'bg-yellow-500';

  if (isLocal) {
    environmentLabel = 'Local Development';
    bgColor = 'bg-blue-500';
  } else if (supabaseUrl.includes('staging')) {
    environmentLabel = 'Staging';
    bgColor = 'bg-orange-500';
  }

  return (
    <div className={`${bgColor} text-white text-center py-1 px-4 text-xs font-medium shadow-sm`}>
      <div className="flex items-center justify-center gap-2">
        <span className="inline-block w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
        <span className="uppercase tracking-wide">{environmentLabel} Environment</span>
        <span className="inline-block w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
      </div>
    </div>
  );
};

export default DevelopmentBanner;
